import { render, staticRenderFns } from "./contractSpecificationFilters.vue?vue&type=template&id=58b15416&scoped=true&"
import script from "./contractSpecificationFilters.vue?vue&type=script&lang=js&"
export * from "./contractSpecificationFilters.vue?vue&type=script&lang=js&"
import style0 from "./contractSpecificationFilters.vue?vue&type=style&index=0&id=58b15416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b15416",
  null
  
)

export default component.exports